import styled from 'styled-components';

import { Button } from '@xing-com/button';

export const PaginationButtonLayout = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: var(--spaceXL);
`;

export const PaginationButton = styled(Button)`
  margin: var(--spaceXL);
`;
